import React from "react";
import { useSelector } from "react-redux";
import { Modal, Text } from "@telia/teddy";
import { RootState } from "../../../../../../models";
import { getCustomerExistingAccounts, getExistingPhoneNumberLookup } from "../../../state/selectors/customerSelectors";
import ExistingSubscriptionCard from "../ExistingSubscriptionCard/ExistingSubscriptionCard";
import "./ProductUserSubscriptionModal.less";

interface Props {
    open: boolean;
    onClose: () => void;
}

const noop = () => {};

const ProductUserSubscriptionModal: React.FC<Props> = ({ open, onClose }) => {
    const existingAccounts = useSelector((state: RootState) => getCustomerExistingAccounts(state));
    const existingPhoneNumberLookup = useSelector((state: RootState) => getExistingPhoneNumberLookup(state));

    const subscription = existingAccounts
        .flatMap((account) => account.subscriptions)
        .find((sub) => sub.phoneNumber === existingPhoneNumberLookup);

    return (
        <Modal open={open} onOpenChange={(isOpen) => !isOpen && onClose()}>
            <Modal.Overlay className="product-user-subscription-modal">
                <Modal.Content className="product-user-subscription-modal__content" size="lg">
                    <Modal.Group variant="title">
                        <Modal.Close aria-label="lukk" slot="floating" onClick={onClose} />
                    </Modal.Group>
                    {subscription ? (
                        <ExistingSubscriptionCard
                            sub={subscription}
                            subscriptionInfo={subscription}
                            selectedSubscription={subscription.phoneNumber}
                            handleSelect={noop}
                            handleChangeSubscription={noop}
                            readOnly
                        />
                    ) : (
                        <Text as="p">Fant ikke abonnementet til brukeren.</Text>
                    )}
                </Modal.Content>
            </Modal.Overlay>
        </Modal>
    );
};

export default ProductUserSubscriptionModal;
